import {
  BULK_CASE_ACTION_KIND,
  BULK_QUEUE_RUN_STATUS,
} from '@app/constants/queue';
import { BULK_QUEUE_IN_PROGRESS_TOAST_ID } from '@app/constants/service';
import i18n, { NAMESPACE } from '@app/i18n';
import type { BulkQueueRunComplete } from '@app/services/bulk-queue';
import { toaster } from '@chakra-primitives/toaster';

// The submitter may be anywhere when a run finishes, so the queues bundle may be unloaded.
export const showBulkQueueRunCompleteToast = async (
  run: BulkQueueRunComplete,
  onViewDetails: () => void,
): Promise<void> => {
  await i18n.loadNamespaces([NAMESPACE.QUEUES, NAMESPACE.COMMON]);

  const moved = run?.succeededCount ?? 0;
  const skipped = run?.skippedCount ?? 0;
  const failed = run?.failedCount ?? 0;
  const unresolved = skipped + failed;
  const ranToCompletion = run?.status === BULK_QUEUE_RUN_STATUS.COMPLETED;

  const type = (() => {
    if (!ranToCompletion) return 'error';
    return unresolved > 0 ? 'warning' : 'success';
  })();

  const titleKey = (() => {
    if (!ranToCompletion) return 'incompleteTitle';
    const isRemove = run?.kind === BULK_CASE_ACTION_KIND.QUEUE_REMOVE;
    if (moved === 0) return isRemove ? 'noneRemovedTitle' : 'noneAssignedTitle';
    return isRemove ? 'removedTitle' : 'title';
  })();

  toaster.dismiss(BULK_QUEUE_IN_PROGRESS_TOAST_ID);
  toaster.create({
    type,
    title: i18n.t(`${NAMESPACE.QUEUES}:bulkQueueRunComplete.${titleKey}`),
    description: i18n.t(`${NAMESPACE.QUEUES}:bulkQueueRunComplete.summary`, {
      moved,
      skipped,
      failed,
    }),
    ...(unresolved > 0
      ? {
          action: {
            label: i18n.t(
              `${NAMESPACE.QUEUES}:bulkQueueRunComplete.viewDetails`,
            ),
            onClick: onViewDetails,
          },
        }
      : {}),
  });
};

export default showBulkQueueRunCompleteToast;
